import { mapActions, mapGetters } from "vuex";
import appHeader from "@shared/app-header";
import appFooter from "@shared/app-footer";
import appSidebar from "@/components/app-sidebar";
import alert from "@/components/alert-box";
import pagination from "@/components/pagination";
import { checkPermission } from "@shared/utils/functions";

export default {
  name: 'dashboard',

  components: {
    appHeader,
    appFooter,
    appSidebar,
    alert,
    pagination,
  },

  data () {
    return {
      isLoading: true,
      footerWidth: ""
    }
  },

  title: "Dashboard",

  computed: {
    ...mapGetters([
      "getTenantId",
      "getNotificationCount",
      "appThemeColors",
      "getClientId",
      "getFooterText",
      "getFooterFields",
      "getUseFooter",
    ]),

    themeColors() { 
      return this.appThemeColors;
    },
    paddingBottom() {
      // if footer is visible or not visible
      // if (this.getUseFooter && !this.$route.path.includes('footer-content')) { 
      //   return '88px'
      // } else {
        return '16px'
      // }
    },
    containerHeight() {
      // if footer is visible or not visible
      if (this.getUseFooter && !this.$route.path.includes('footer-content')) { 
        return 'calc(100% - 144px)'
      } else {
        return 'calc(100% - 72px)'
      }
    },

  // linkify() {
  //   let text = this.getFooterText;
  //       // Match only <a> tags with href (http or https)
  //       const anchorTagWithHrefRegex = /<a\s+[^>]*href=(["'])(https?:\/\/[^"']+)\1[^>]*>.*?<\/a>/gi;
  //       const preservedAnchors = [];

  //       // 1. Extract valid <a> tags with href, and ensure target/rel exists
  //       text = text.replace(anchorTagWithHrefRegex, (match) => {
  //         // Add target="_blank" and rel="noopener noreferrer" if missing
  //         let updated = match;

  //         if (!/target=("|')_blank\1/.test(updated)) {
  //           updated = updated.replace(
  //             /<a/i,
  //             `<a target="_blank" rel="noopener noreferrer"`
  //           );
  //         }

  //         preservedAnchors.push(updated);
  //         return `[[ANCHOR_${preservedAnchors.length - 1}]]`;
  //       });

  //       // 2. Convert plain URLs to links
  //       const urlRegex = /(https?:\/\/[^\s<]+)/g;
  //       text = text.replace(urlRegex, (url) => {
  //         return `<a href="${url}" target="_blank" rel="noopener noreferrer" style="color: blue; text-decoration: underline;">${url}</a>`;
  //       });

  //       // 3. Restore preserved anchor tags
  //       text = text.replace(/\[\[ANCHOR_(\d+)\]\]/g, (match, index) => preservedAnchors[index]);

  //       return text;
  //     }
  },

  async mounted () {
    this.isLoading = true;
    await this.fetchNewTenantId();
    await this.initApp();
    await this.fetchFooterDetails();
    this.isLoading = false;
    this.checkBreakpoints();
    window.addEventListener('resize', this.checkBreakpoints);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.checkBreakpoints);
  },

  methods: {
    checkPermission,
    ...mapActions({
      fetchNotificationCount: "fetchNotificationCount",
      fetchUIConf: "fetchUIConf",
      fetchTenantId: "fetchTenantId",
      fetchUserLangPreference: "LocalizationStore/fetchUserLangPreference",
      fetchFooterDetails: "fetchFooterDetails"
  }),

  handelSidebarToggle(isCollapsed){
    this.checkBreakpoints(isCollapsed);
  },

  checkBreakpoints(isCollapsed = true) {
    if(isCollapsed) {
       this.footerWidth = 'calc(100% - 4rem)';
       return;
    }
    const isXl = window.matchMedia('(min-width: 1280px)').matches;
    const isMd = window.matchMedia('(min-width: 768px)').matches;
    const isSm = window.matchMedia('(min-width: 640px)').matches;

    if(isXl) {
      this.footerWidth = 'calc(100% - 15rem)';
    } else if(isMd || isSm) {
      this.footerWidth = 'calc(100% - 14rem)';
    }
  },

    async fetchNewTenantId() {
      await this.fetchNotificationCount()
    },

    async initTenant() {
      try {
        await this.fetchTenantId();
      } catch(e) {
        this.$toast.error("Initialization error");
      } 

      if (this.getTenantId) {
        await this.fetchUIConf(this.getTenantId);
      }
    },

    async initLang() {
      if (!this.checkPermission("language.language_dropdown")) return;
      try {
        await this.fetchUserLangPreference();
      } catch (error) {
        console.error("Failed to load language preferences", error);
      }
    },

    changeLanguage() {
      if (this.$route.path.includes('bi-dashboard-view'))
        this.$refs?.['router-component']?.reloadBoldBIDashboard();
    },

    async initApp() {
      await Promise.all([
        this.initTenant(),
        this.initLang(),
      ])
    }
  },
}
